import { render } from "./ContentsListArea.vue?vue&type=template&id=1451964d&scoped=true"
import script from "./ContentsListArea.vue?vue&type=script&lang=js"
export * from "./ContentsListArea.vue?vue&type=script&lang=js"

import "./ContentsListArea.vue?vue&type=style&index=0&id=1451964d&scoped=true&lang=stylus"

import exportComponent from "K:\\ダウンロード\\生活サイト対応\\after\\sei_2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1451964d"]])

export default __exports__